import React from 'react'


export default function ProgressBar(props) {
    
    const maxNumOfPages = 12;
    const percentageNum = Math.round((props.pageNum-1) * (100/(maxNumOfPages-1)));
    const progressBarStyle = {
        width: `${percentageNum}%`
    }
    
    return (
        <div className="ProgressBar">
            <div className="ProgressBar--text">
                <h1 className="ProgressBar--title">Cofounders Matching Tool</h1>
                <h1 className="ProgressBar--percentage">{percentageNum}%</h1>
            </div>
            <div className="ProgressBar--container">
                <div className="ProgressBar--bar"></div>
                <div className="ProgressBar--active" style={progressBarStyle}></div>
            </div>
        </div>
    )
}